import PropTypes from "prop-types";
import merge from "lodash/merge";
import ReactApexChart from "react-apexcharts";
import { useState, useEffect } from "react";
// @mui
import { styled } from "@mui/material/styles";
import { Card, CardHeader, Stack, Select, MenuItem } from "@mui/material";
// components
import { BaseOptionChart } from "../../../components/chart";
import { useAppDispatch } from "../../../core/redux/hooks";

// ----------------------------------------------------------------------

const CHART_HEIGHT = "fit-content";

const LEGEND_HEIGHT = 72;

export const ChartWrapperStyle = styled("div")(({ theme }) => ({
  height: CHART_HEIGHT,
  marginTop: theme.spacing(2),
  "& .apexcharts-canvas svg": {
    height: CHART_HEIGHT,
  },
  "& .apexcharts-canvas svg,.apexcharts-canvas foreignObject": {
    overflow: "visible",
  },
  "& .apexcharts-legend": {
    height: LEGEND_HEIGHT,
    alignContent: "center",
    position: "relative !important",
    borderTop: `solid 1px ${theme.palette.divider}`,
    top: `calc(${CHART_HEIGHT - LEGEND_HEIGHT}px) !important`,
  },
}));

// ----------------------------------------------------------------------

AppCurrentSubject.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
  chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default function AppCurrentSubject({
  title,
  subheader,
  chartData,
  chartColors,
  chartLabels,
  ...other
}) {
  const dispatch = useAppDispatch();
  const [projection, setProjection] = useState("30-days");

  const chartOptions = merge(BaseOptionChart(), {
    stroke: { width: 2 },
    fill: { opacity: 0.48 },
    chart: {
      width: "800px", // Adjust the width as needed
      height: "600px", // Adjust the height as needed
    },
    legend: { floating: true, horizontalAlign: "center" },
    xaxis: {
      categories: chartLabels,
      labels: {
        style: {
          colors: chartColors,
        },
      },
    },
  });

  const handleProjection = (e) => {
    setProjection(e.target.value);
  };

  useEffect(() => {
    if (other.fetchFn) {
      dispatch(other.fetchFn(projection));
    }
  }, [projection]);

  return (
    <Card {...other}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        p={1}
      >
        <CardHeader title={title} subheader={subheader} />

        <Select value={projection} onChange={handleProjection}>
          <MenuItem value={"all"}>In months</MenuItem>
          <MenuItem value={"90-days"}>last 90 days</MenuItem>
          <MenuItem value={"30-days"}>last 30 days</MenuItem>
          <MenuItem value={"14-days"}>last 14 days</MenuItem>
          <MenuItem value={"7-days"}>last 7 days</MenuItem>
        </Select>
      </Stack>

      <ChartWrapperStyle dir="ltr">
        <ReactApexChart
          type="radar"
          series={chartData}
          options={chartOptions}
          height={"700px"}
        />
      </ChartWrapperStyle>
    </Card>
  );
}
